import { render, staticRenderFns } from "./GroupNew.vue?vue&type=template&id=acc47b0c&scoped=true"
import script from "./GroupNew.vue?vue&type=script&lang=js"
export * from "./GroupNew.vue?vue&type=script&lang=js"
import style0 from "./GroupNew.vue?vue&type=style&index=0&id=acc47b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc47b0c",
  null
  
)

export default component.exports